<template>
<m-pageframe
    title="{organization-label}: Lightbox Submissions"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickExport()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create,'date')}}
        </template>

        <template v-slot:item.time_create_time="{ item }">
            {{$rc.pretty(item.time_create,'time')}}
        </template>

        <template v-slot:item.time_double_opt_in_date="{ item }">
            {{$rc.pretty(item.time_double_opt_in,'date')}}
        </template>

        <template v-slot:item.time_double_opt_in_time="{ item }">
            {{$rc.pretty(item.time_double_opt_in,'time')}}
        </template>

         <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint_no_parens')}}
        </template>

        <template v-slot:item.is_test_submission="{ item }">
            <v-simple-checkbox
                disabled
                :value="item.is_test_submission"
            />
        </template>
    
    </v-data-table>

    <!-- Footnote for State column -->
    <div class="mt-3 text-caption text--secondary">
        <strong>*</strong> State -- The outcome of the double opt-in process from this lightbox submission -- later changes in consent will not be reflected
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            results: [],

            headers: [
                { text: 'Test', value: 'is_test_submission'},
                { text: 'Lightbox', value: 'lightbox_label'},
                { text: 'Date', value: 'time_create_date'},
                { text: 'Time', value: 'time_create_time'},

                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Email', value: 'email'},
                { text: 'Phone', value: 'endpoint'},
                { text: 'Birthday', value: 'birthday'},


                { text: 'State *', value: 'state'},
                { text: 'Double Opt In Date', value: 'time_double_opt_in_date'},
                { text: 'Double Opt In Time', value: 'time_double_opt_in_time'},
            ],

            full_text: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/lightbox/submissions',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list lightbox submissions',
            });
        },
        
        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/lightbox/submissions',
                    {
                        'organization_id': this.$route.params.organization_id,
                    }
                );
        }
    },
}
</script>

<style lang="scss" scoped>
</style>